
const ImportanceSection = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 text-center">
            The Importance of Safety Training
          </h2>
          
          <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
            <p>
              Safety training is a legal requirement. However, safety training is also essential to maintaining a safe and productive work environment to attract and retain quality employees while minimizing business costs.
            </p>
            
            <p>
              According to OSHA regulations, you must train every employee on the specific hazards they may encounter in their daily work activities. Whether you operate in construction, manufacturing, distribution, healthcare, or any other industry, ensure employees complete expert training to recognize and manage workplace hazards.
            </p>
          </div>
          
          <div className="text-center mt-8">
            <button className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImportanceSection;